import { Grid, Typography } from '@mui/material';
import { TitleV1Props } from './props';

export const TitleV1 = ({ title, bg = '#f2f5fc', children }: TitleV1Props) => {
    return (
        <Grid
            container
            bgcolor={bg}
            p="14px"
            display="flex"
            alignItems="center"
        >
            <Grid item xs={12} sm={6}>
                <Typography
                    sx={{
                        textAlign: {
                            xs: 'center',
                            sm: 'left',
                        },
                        color: 'primary.main',
                    }}
                >
                    {title}
                </Typography>
            </Grid>
            <Grid
                item
                xs={12}
                sm={6}
                display="flex"
                gap="16px"
                sx={{
                    justifyContent: {
                        xs: 'center',
                        sm: 'flex-end',
                    },
                    alignItems: 'center',
                }}
            >
                {children}
            </Grid>
        </Grid>
    );
};
